// The /api/chat request body, built per send (the transport reads it for every
// request). `voice` is present only on a voice-origin turn (BUILD 2 C2-7), so a
// typed turn's body is unchanged. Extracted from app.tsx so its shape is unit
// tested (test/chat-request-body-unit.mjs).
import type { VoiceTurnBody } from '@/voice/contracts';
import { RENDERERS } from '@/render-kit/registry';

export type ChatRequestInput = {
  threadId: string;
  packIds: string[];
  /** Local-only model override; ignored by the server unless the local picker is armed. */
  model: string | null;
  timezone: string;
  locale: string;
  narrow: boolean;
  voice: VoiceTurnBody | null;
  personality: string | null;
};

export function chatRequestBody(input: ChatRequestInput) {
  return {
    // thread_id lets the server attribute a `/feedback <note>` command to this
    // conversation (the client owns the thread id; /api/chat is otherwise stateless).
    thread_id: input.threadId,
    packIds: input.packIds,
    ...(input.model ? { model: input.model } : {}),
    timezone: input.timezone,
    locale: input.locale,
    viewport: input.narrow ? 'narrow' : 'wide',
    ...(input.voice ? { voice: input.voice } : {}),
    ...(input.personality ? { personality: input.personality } : {}),
    // The in-chat cards this build can draw; the server offers no others.
    ui: { renderers: [...RENDERERS] },
  };
}
